module.exports = __webpack_public_path__ + "img/history_icon.cbab0dc5.svg";